import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../aura';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';
import { useFormErrors } from './helpers/use-form-errors';

const MAX_LENGTH = 20;

export function PostalCode(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'postalCode' });
  const {
    data: { address },
    setData,
  } = useFormContext();
  const { props: formErrorsProps, clear } = useFormErrors('address', true);

  const hasValue = useCallback(
    // TODO: improve postal code validation
    (data: FormContextData) =>
      data.address.postalCode ? null : 'PostalCode is empty',
    [],
  );
  const validate = useCallback((data: FormContextData) => {
    if (!data.address.postalCode) {
      return 'PostalCode is empty';
    }
    if (data.address.postalCode.length > MAX_LENGTH) {
      return 'Address.PostalCode is too long';
    }
    return null;
  }, []);
  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      clear();
      setData(current => ({
        ...current,
        address: { ...current.address, postalCode: value },
      }));
    },
    [setData, clear],
  );

  return (
    <Input
      id="postal-code"
      type="text"
      label={t('label')}
      value={address.postalCode}
      onValueChange={onValueChange}
      autoComplete="postal-code"
      maxLength={MAX_LENGTH}
      {...extraInputProps}
      {...formErrorsProps}
    />
  );
}
